import { React, useEffect } from "react";

import MapWithSideBar from "./MapWithSideBar";
import Filters from "./Filters";
import Breadcrumb from "../../components/Breadcrumbs";
import MultiManual from "../../components/Manual/MultiManual";
import { useMapFilter } from "../../hooks/map/useMapFilter";

const Mapa = () => {
  const { fetchData } = useMapFilter();

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="map-container">
      <Breadcrumb
        paths={[
          { href: "/", name: "Mapa" },
          { href: "/", name: "Mapa de Ocorrências" },
        ]}
      />

      <div
        style={{
          borderRadius: "17px",
          backgroundColor: "#F5F5F5",
        }}
      >
        <Filters />
        <MapWithSideBar />
      </div>

      <MultiManual
        components={[
          {
            id: "filters-grid",
            message: `Você pode filtrar as ocorrências que deseja ver por aqui`,
            padding: 20,
          },
          {
            id: "map-side",
            message: `Observe as ocorrências filtradas por aqui`,
            padding: 20,
          },
        ]}
      />
    </div>
  );
};

export default Mapa;
